<template>
  <div class="tabs is-boxed">
    <ul>
      <router-link
        v-slot="{ href, navigate, isActive }"
        :to="{ name: 'products.edit.gr', params: { uuid } }"
        custom
      >
        <li :class="[isActive && 'router-link-active is-active']" role="link">
          <a :href="href" @keypress.enter="navigate" @click="navigate">
            <span>Ελληνικά</span>
            <span class="icon fa flag-icon flag-icon-gr" />
          </a>
        </li>
      </router-link>
      <router-link
        v-slot="{ href, navigate, isActive }"
        :to="{ name: 'products.edit.en', params: { uuid } }"
        custom
      >
        <li :class="[isActive && 'router-link-active is-active']" role="link">
          <a :href="href" @keypress.enter="navigate" @click="navigate">
            <span>Αγγλικά</span>
            <span class="icon fa flag-icon flag-icon-gb" />
          </a>
        </li>
      </router-link>
      <router-link
        v-slot="{ href, navigate, isActive }"
        :to="{ name: 'products.edit.loyalty', params: { uuid } }"
        custom
      >
        <li :class="[isActive && 'router-link-active is-active']" role="link">
          <a :href="href" @keypress.enter="navigate" @click="navigate">
            <span>Loyalty</span>
          </a>
        </li>
      </router-link>
      <router-link
        v-slot="{ href, navigate, isActive }"
        :to="{ name: 'products.edit.family', params: { uuid } }"
        custom
      >
        <li :class="[isActive && 'router-link-active is-active']" role="link">
          <a :href="href" @keypress.enter="navigate" @click="navigate">
            <span>Family</span>
          </a>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uuid: this.$route.params.uuid,
    };
  },
};
</script>
